module.exports = __webpack_public_path__ + "img/petstairs37.b3a5465b.jpg";